import { KlicB2bRestVerblijfsobject } from '@shared/klic-b2b-rest';
import { Geometry } from 'geojson';
import type { AanvraagSoort } from '@shared/aanvraag-soort';

export interface ShopStateModel {
  type: AanvraagSoort;
  startDate: string;
  endDate: string;
  executionDate: string;
  activities: string[];
  geometries: Geometry[];
  informationPolygonGeometries: Geometry[];
  addedOn: string;
  closestAddresses: KlicB2bRestVerblijfsobject[];
  selectHouseConnections: boolean;
  selectedHouseConnections: KlicB2bRestVerblijfsobject[];
  notitie: string;
  reference: string;
  projectId: string | null;
}

export class SetShoppingCartContent {
  static readonly type = '[Shop] Set cart state';
  constructor(public payload: Partial<ShopStateModel>) {}
}

export class ResetShop {
  static readonly type = '[Shop] Reset Shop';
  constructor(public payload: { remember_klic_order_details: boolean }) {}
}
